export interface IServiceTemplateForm {
	description: string;
}

export const emptyTemplateForm: IServiceTemplateForm = {
	description: "",
};
